import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { useCustomAddressStore } from "../stores/customAddressStore";
import { CustomAddressForm } from "./CustomAddressForm";

export function CustomAddressDrawer() {
  const drawerOpen = useCustomAddressStore((s) => s.drawerOpen);
  const selectedIdx = useCustomAddressStore((s) => s.selectedIdx);
  const closeDrawer = useCustomAddressStore((s) => s.closeDrawer);
  const isEditMode = selectedIdx != null;

  return (
    <Sheet
      open={drawerOpen}
      onOpenChange={(open) => {
        if (!open) closeDrawer();
      }}
    >
      <SheetContent side="right" className="flex flex-col overflow-hidden p-0 sm:max-w-[720px]">
        <SheetHeader className="shrink-0 px-4 pt-4 pb-2">
          <SheetTitle className="text-sm">{isEditMode ? "보완 주소 수정" : "보완 주소 등록"}</SheetTitle>
          <SheetDescription className="text-xs">
            주소 검색(카카오)에 없는 실재 지점을 전사 공용으로 등록합니다. 저장 즉시 모든 업체의 주소 검색에 제안됩니다.
          </SheetDescription>
        </SheetHeader>
        <CustomAddressForm
          key={selectedIdx ?? "add"}
          mode={isEditMode ? "edit" : "add"}
          caIdx={selectedIdx}
        />
      </SheetContent>
    </Sheet>
  );
}
